const nunjucks = require('nunjucks');
const nodup_action = require('../nodup_action');
const exception = require('../exception');

const {
    compose_event_handler_initializer,
    delay,
    compose_ajax    
} = require("../util");


const loadJSON = ()=>{

    let hoge=[
        {
            "type":"text_v1_00",
            "query_name":"name",
            "name":"名前"
        },
        {
            "type":"mail_v1_00",
            "query_name":"email",
            "name":"メールアドレス"
        },
        {
            "type":"querytype_v1_00",
            "query_name":"querytype",
            "name":"お問い合わせの種類"
        },
        {
            "type":"textarea_v1_00",
            "query_name":"content",
            "name":"お問い合わせの内容"
        }


    ];
    return hoge;
}

const clear_error_bullet = () => {
    let ary_DOM_bullet_list_to_clear = document.querySelectorAll('.bullet-list[class$="-error"]');
    ary_DOM_bullet_list_to_clear.forEach(e=>e.replaceChildren());
}

// WIP:バグがあるはずなので治す
// バックエンド作らないと最後まで走らない
const func_activate_send_button= (selector_button,target,id_form,verify_url,operation_url)=>{
    //const selector_button=".button.inquery";
    const nodup_action_name=id_form;
    const selector_form=`#${id_form} form`;
    return compose_event_handler_initializer(selector_button,(e)=>{
        let routine = Promise.resolve();
    
        e.preventDefault();
    
        if(nodup_action.is_action_disabled(nodup_action_name)) return routine;
    
        routine = routine.then(
            ()=>{
                nodup_action.disable_action(nodup_action_name);
                return delay(1000/60*8);
            }
        );
    
        routine = routine.then(
            compose_ajax({
                verify_url:verify_url,
                form_data_verify:()=>{
                    const DOM_form=document.querySelector(selector_form);
                    const query_param = new URLSearchParams(new FormData(DOM_form));
                    
                    clear_error_bullet();
                    
                    query_param.append('target',target);
    
                    return query_param;
                },
                operation_url:operation_url,
                form_data_operation:(json,query_param)=>{
                    //json_ajax_result = json;
                    switch(json.cause){
                        case "VerifyPassed":
                            query_param.append('token',json.token);
                            break;
                        default:
                            let error = new exception.ValidateError();
                            error.json = json;
                            throw error;
                    }
                    return query_param;
                },
                closing:(json)=>{
                    //modal_finish_banktransfer.show();
                    nodup_action.enable_action(nodup_action_name);
                    console.log(json);
    
                }
            })                
        );
    
    
        routine = routine.catch(
            (err)=>{
                nodup_action.enable_action(nodup_action_name);
                if(err instanceof exception.ValidateError) {
                    //rollback_to_form(selector_jump_point_for_top_of_form);
                    //show_plate_invalid_input(true);
                    var ary_error_json=err.json;
                    for(let verify_result of ary_error_json.ary_verify_result){
                        // verify_result.query_name
                        // verify_result.source
                        // verify_result.message.detail
                        let selector_error_bullet = `.bullet-list.${id_form}-${verify_result.query_name}-error`;
                        let DOM_error_bullet = document.querySelector(selector_error_bullet);
    
                        if(DOM_error_bullet === null) {
                            alert(`.bullet-list.${id_form}-${verify_result.query_name}-error`);
                            debugger;
                        } else {
                            var insertHTML = `<div class="bullet-item fs10"><span>${verify_result.message.detail}</span></div>`;
                            DOM_error_bullet.replaceChildren();
                            DOM_error_bullet.insertAdjacentHTML('afterbegin',insertHTML);
                        }
                    }
    
                } else {
                    throw err;
                }
            }
        );
    });    
}

class ExternMailform extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const mailFormUrl = () => this.getAttribute('src');
    const id_element = () => this.getAttribute('id');
    let url = mailFormUrl();
    let ary_html_item_input=new Array();

    let routine = Promise.resolve();

    
    const DOM_mailform = () => document.querySelector(`#${id_element()} form`);

    routine = routine.then(
        ()=>{
            return fetch(url);
        }
    );
    routine = routine.then(response => response.text());
    routine = routine.then(
        (text)=>{
            let temp_DOM_container = document.createElement('div');
            temp_DOM_container.insertAdjacentHTML('afterbegin',text);
            temp_DOM_container.firstElementChild.id=id_element();
            this.replaceWith(temp_DOM_container.firstElementChild);
            return;
        }
    );
    routine = routine.then(
        ()=>{
            let html_item_input;

            let id_mailform=id_element();
            let json_form = loadJSON();

            for(let record_input of json_form){
                let DOM_template = document.querySelector(`#${id_element()} template.input_${record_input['type']}`);
                let html_template = DOM_template.innerHTML;
    
                html_item_input = nunjucks.renderString(html_template,{id_element:id_mailform,record_input:record_input});
                ary_html_item_input.push(html_item_input);
            }

            return;
        }
    );
    routine = routine.then(
        ()=>{
            let DOM_form = DOM_mailform();
            let html_mailform = ary_html_item_input.join('');
            DOM_form.insertAdjacentHTML('afterbegin',html_mailform);
            //DOM_form.insertAdjacentHTML('beforebegin',html_mailform);
            return;
        }
    );

    routine = routine.then(
        ()=>{
            let id_mailform=id_element();
            let nodup_action_name=`${id_mailform}`;
            let verify_url="https://www.ushiya.site:4011/verify";
            let operation_url="https://www.ushiya.site:4011/operation";
            let target="inquery_form";
            let activate_send_button = func_activate_send_button(`#${id_mailform} .button.inquery`,target,nodup_action_name,verify_url,operation_url);

            const handler_nodup = nodup_action.generic_handler({
                handler_name:id_mailform, 
                selector_element_for_action:`#${id_mailform} form .button.inquery`
            });
            nodup_action.regist_action(nodup_action_name);
            nodup_action.regist_handler(nodup_action_name,handler_nodup);
            
            activate_send_button();
            return;
        }
    );

    return routine;
  }

}

module.exports.define_mailform_element = () => {
    customElements.define('extern-mailform', ExternMailform);
}